module.exports = __webpack_public_path__ + "img/tongues.19cfa0cd.png";